import ProjectItem from "./ProjectItem";
import { useMemo } from "react";

interface ProjectListProps {
  projects: any[];
  headingCopy?: string;
  selectedType?: string;
  isEmbedded?: boolean;
  theme?: string;
  refPageSlug?: string;
  refPageType: string;
  refPageLabel: string;
  projectCardLocation: string;
}

function ProjectList({
  projects,
  selectedType,
  isEmbedded,
  theme,
  refPageSlug,
  refPageType,
  refPageLabel,
  projectCardLocation,
}: ProjectListProps) {
  const filteredProjects = useMemo(() => {
    if (selectedType === "All" || selectedType === undefined) {
      return projects;
    } else {
      return projects.filter((project) => project.type === selectedType);
    }
  }, [projects, selectedType]);

  return (
    <div className="mx-auto max-w-7xl">
      <div className="mx-auto mt-4 grid h-auto max-w-7xl grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {filteredProjects.map((project, index) => (
          <ProjectItem
            key={index}
            project={project}
            isEmbedded={isEmbedded}
            theme={theme}
            refPageSlug={refPageSlug}
            refPageType={refPageType}
            refPageLabel={refPageLabel}
            projectCardLocation={projectCardLocation}
          />
        ))}
      </div>
    </div>
  );
}

export default ProjectList;
